import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Survey, SurveyInfoType } from 'src/app/models';
import { DialogService } from 'src/app/services';

@Component({
  selector: 'app-surveys-info',
  templateUrl: './surveys-info.component.html',
  styleUrls: ['./surveys-info.component.scss'],
})
export class SurveysInfoComponent implements OnInit, OnChanges {
  @Input() surveys: Survey[];
  public hasSurveyInfo = true;
  constructor(private dialog: DialogService) {}

  ngOnInit(): void {
    this.checkSurveyInfo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.surveys = changes.surveys.currentValue;
    this.checkSurveyInfo();
  }

  public onOpenCopyright(): void {
    this.dialog
      .surveysInfo(SurveyInfoType.copyright, this.surveys)
      .afterClosed();
  }

  public onOpenSurveyInfo(): void {
    this.dialog.surveysInfo(SurveyInfoType.info, this.surveys).afterClosed();
  }

  private checkSurveyInfo(): void {
    this.hasSurveyInfo =
      this.surveys?.filter((survey: Survey) => survey.meta?.['survey-info'])
        .length > 0;
  }
}
